var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCropHealthy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.11723 5.20532C1.13465 4.99696 1.3151 4.84054 1.52382 4.85286C4.77042 5.04455 8.16362 6.80516 10.6693 9.38558C13.1764 11.9675 14.8399 15.4179 14.5433 19.0251C14.5259 19.2372 14.3399 19.3949 14.1278 19.3775C13.9158 19.36 13.758 19.174 13.7755 18.962C14.049 15.6353 12.5152 12.3925 10.1165 9.9223C7.8161 7.55321 4.76151 5.93856 1.8552 5.65172C1.56968 9.60149 1.99384 13.3838 3.30278 16.2477C4.645 19.1843 6.90555 21.142 10.3181 21.3751C10.5303 21.3896 10.6906 21.5734 10.6761 21.7857C10.6616 21.9979 10.4778 22.1583 10.2655 22.1438C6.51683 21.8877 4.03728 19.7081 2.60207 16.5679C1.17575 13.4472 0.769419 9.3655 1.11723 5.20532Z",
    fill: "#18C60B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34236 7.94416C3.48994 7.79092 3.7338 7.78633 3.88704 7.93392C5.10755 9.10937 7.12762 11.4173 8.99133 14.0905C10.8502 16.7568 12.5846 19.83 13.1908 22.5303C13.2374 22.7379 13.1069 22.944 12.8994 22.9906C12.6918 23.0372 12.4857 22.9067 12.4391 22.6991C11.8666 20.1489 10.2033 17.176 8.35933 14.5311C6.52013 11.8931 4.53201 9.62471 3.3526 8.48884C3.19936 8.34126 3.19478 8.0974 3.34236 7.94416Z",
    fill: "#18C60B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5793 1.00067C21.7879 0.988451 21.9682 1.14479 21.9857 1.35303C22.3084 5.20036 21.9767 8.97839 20.7762 11.971C19.5717 14.9735 17.4771 17.2129 14.2844 17.8798C14.0761 17.9233 13.872 17.7898 13.8285 17.5815C13.785 17.3733 13.9186 17.1692 14.1268 17.1257C17.0013 16.5252 18.9245 14.5176 20.0612 11.6841C21.1633 8.93663 21.5113 5.43893 21.2478 1.79945C17.0365 2.21543 12.5482 5.45682 10.5432 9.66366C10.4517 9.85571 10.2218 9.9372 10.0297 9.84567C9.83769 9.75414 9.7562 9.52424 9.84774 9.33219C12.0203 4.77384 16.952 1.27169 21.5793 1.00067Z",
    fill: "#18C60B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7878 4.0382C19.9395 4.18734 19.9416 4.43124 19.7925 4.58296C17.2411 7.17867 15.0097 10.0706 13.1459 13.1969C13.0369 13.3796 12.8005 13.4394 12.6177 13.3305C12.435 13.2215 12.3752 12.9851 12.4841 12.8023C14.3794 9.62321 16.6485 6.68246 19.243 4.04289C19.3922 3.89116 19.6361 3.88906 19.7878 4.0382Z",
    fill: "#18C60B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropHealthy);
export default __webpack_public_path__ + "static/media/crop-healthy.90176eb7a48bd2b3fa39256762dd41eb.svg";
export { ForwardRef as ReactComponent };